import React from 'react'
import WhiteLogo from '../../assets/images/logo-risen-white.svg'
import LoginForm from './LoginForm'
import { Outlet } from 'react-router-dom'

export default function Authentication() {
    return (
        <div className='container-fluid'>
            <div className='row login-main-container'>
                <div className='col-md-6 login-left'>
                    <div className='logo-wrapper'>
                        <img src={WhiteLogo} alt="Logo" />
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className='login-form-wrapper'>
                        <div className='login-form-wrap'>
                            
                            <Outlet />


                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

